module.exports = __webpack_public_path__ + "static/fujipacific-d138a3b77c427c86299e0280d54f5bcd.png";